import { FC } from 'react';
import { GridWrapperNew } from '../grids';
import ProjectCardNew from '../projectCard/projectCardNew';

export const EmptyCardsLoading: FC<{ isLoading: boolean, k?: number }> = ({ isLoading, k }) => {

    if (!isLoading) {
        return null;
    }
    
    return (
        <GridWrapperNew mobileColumns={2}>
          {Array(k === undefined ? 8 : k).fill('').map((_, index) => (
            <ProjectCardNew key={index} isLoading={true} />
          ))}
        </GridWrapperNew>
      );
}import { FC } from 'react';
import { GridWrapperNew } from '../grids';
import ProjectCardNew from '../projectCard/projectCardNew';

export const EmptyCardsLoading: FC<{ isLoading: boolean, k?: number }> = ({ isLoading, k }) => {

    if (!isLoading) {
        return null;
    }
    
    return (
        <GridWrapperNew mobileColumns={2}>
          {Array(k === undefined ? 8 : k).fill('').map((_, index) => (
            <ProjectCardNew key={index} isLoading={true} />
          ))}
        </GridWrapperNew>
      );
}